import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch} from "react-redux";
import { ListItem, ListItemIcon, IconButton, Tooltip, Typography } from "@material-ui/core";
import { MdOutlineContactPage } from 'react-icons/md';
import DeleteIcon from "@material-ui/icons/Delete";
import CreateIcon from "@material-ui/icons/Create";

import { formataCpf, retirarFormatacaoCPF } from "../../Utils/utils";
import { setOpenMenu, setOpenSeguradoForm } from "../../Store/Actions/Reducer/menuActions";

export default function ItemListaSegurado({ segurado, openExclusao, bloquearExclusao = false }) {
    const history = useHistory();
    const dispatch = useDispatch();

    function redirectTo(path, cpf) {
        if (window.location.pathname !== path) {
            history.push(path, { cpf });
        }
    }

    const clicaSegurado = () => {
        dispatch(setOpenMenu(false))
        redirectTo(
            `/segurado/${retirarFormatacaoCPF(segurado.cpf)}`,
            segurado.cpf
        );
    }

    const clicaEditarSegurado = () => {
        dispatch(setOpenSeguradoForm(true, segurado.cpf))
    }

    const clicaExcluirSegurado = () => {
        openExclusao(segurado)
    }

    return (
        <div key={segurado.id} style={{ width: "100%", display: "flex" }}>
            <ListItem
                button
                onClick={clicaSegurado}
            >
                <ListItemIcon>
                    <MdOutlineContactPage size={34} color='gray' />
                </ListItemIcon>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <Typography style={{ color: "#D4BFF9", wordBreak: "break-word", fontSize: 14, paddingBottom: 6 }}>
                        {segurado.nome}
                    </Typography>                    
                    <span>{formataCpf(segurado.cpf)}</span>
                </div>
            </ListItem>
            <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center', paddingTop: 7, paddingLeft: 3, paddingRight: 3, paddingBottom: 5 }}>
                <Tooltip title="Apagar segurado">
                    <IconButton
                        onClick={clicaExcluirSegurado}
                        disabled={bloquearExclusao}
                        style={{ maxHeight: "30px", maxWidth: "30px" }}
                    >
                        <DeleteIcon fontSize='small'/>
                    </IconButton>
                </Tooltip>
                <Tooltip title="Editar segurado">
                    <IconButton                        
                        onClick={clicaEditarSegurado}
                        style={{ maxHeight: "30px", maxWidth: "30px" }}
                    >
                        <CreateIcon fontSize='small' />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    );    
}
